//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CoreVirtualDeviceMonitoringCardSkeleton'
};